class MenuContainer {
  constructor() {
    this.menuOptionsTypes = {
      users: {
        id: 'users',
        label: 'Users',
        path: '/users',
      },
      accounts: {
        id: 'accounts',
        label: 'Accounts',
        path: '/accounts',
      },
    };
    this.menuOptions = [];
  }
  $onInit() {
    this.menuOptions = [
      this.menuOptionsTypes.users,
      this.menuOptionsTypes.accounts,
    ];
  }
}

export default {
  controller: MenuContainer,
  template: `
    <menu
      options="$ctrl.menuOptions"
      selected="$ctrl.selected"
    ></menu>
  `,
  bindings: {
    selected: '@',
  },
};
